import { render } from "./SoftSkillsDynamics.vue?vue&type=template&id=45e645b4&scoped=true"
import script from "./SoftSkillsDynamics.vue?vue&type=script&lang=js"
export * from "./SoftSkillsDynamics.vue?vue&type=script&lang=js"

import "./SoftSkillsDynamics.vue?vue&type=style&index=0&id=45e645b4&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e645b4"]])

export default __exports__